import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const bamboo = defineConnector({
  identifier: "bamboo",
  name: "Bamboo",
  tagLine: "Atlassian CI/CD server",
  logo,
  protocol: "http",
  tags: ["engineering"],
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Enter your Bamboo instance URL",
      items: [
        {
          kind: "markdown",
          content:
            "Provide the URL of your Bamboo instance (e.g. `https://bamboo.example.com`).",
        },
        {
          kind: "url",
          label: "Instance URL",
          required: true,
          target: { kind: "configuration", field: "instanceUrl" },
          placeholder: "https://bamboo.example.com",
        },
      ],
    },
    {
      title: "Enter your personal access token",
      items: [
        {
          kind: "markdown",
          content:
            "In Bamboo, go to **Profile → Personal access tokens** and create a new token.",
        },
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "accessToken" },
        },
      ],
    },
  ],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/rest/api/latest/info`,
  },
});
